import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axiosInstance from '../axiosInstance';
import MyChatComponent from './MyChatComponent'; // Import MyChatComponent
import MyUserContext from '../myUserContext'; // Import MyUserContext
import TagsInput from './TagsInput';
import { Drawer } from "@mantine/core";

const ArtEventDropdown = ({ eventId, onClose, language, eventType="artEvent", initialArtEvent = null, art: artProp = null }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate(); // Initialize useNavigate
  const [artEvent, setArtEvent] = useState(initialArtEvent);

  const updateArtEvent = () => {
    if (initialArtEvent) {
      return; // Skip fetching if initialArtEvent is provided
    }

    if (eventType === 'recommendation') { // it will live, or not
      axiosInstance
      .get(`/recommendations/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.recommendation,
          art: response.data.art,
          fromUser: response.data.fromUser,
          toUser: response.data.toUser,
          chat: response.data.chat,
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }

    if (eventType === 'artEvent') {
      axiosInstance
      .get(`/artEvents/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.event,
          art: response.data.art,
          chat: response.data.chat,
          eventOwnerUserName: response.data.eventOwnerUserName,
          eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }
  };

  useEffect(() => {
    updateArtEvent();
  }, []);

  if (!artEvent) {
    return <div></div>;
  }
  
  let actualEventType = eventType;
  if (eventType === "artEvent") {
    if (artEvent.event.type === 1) {
      actualEventType = "finished";
    } else if (artEvent.event.type === 2) {
      actualEventType = "todo";
    } else if (artEvent.event.type === 3) {
      actualEventType = "like";
    }
  } // else it's recommendation

  return (
    <Drawer opened onClose={onClose} position="bottom" size="75vh" radius="md" padding="md"
      title={
        <span style={{ fontWeight: 700 }}>
          {language === "ru" ? "Чат в моей библиотеке" : "Chat in my library"}
          <span
            onClick={() => navigate(`/artEvents/${eventId}`)}
            className="cursor-pointer hover:underline"
            style={{ fontWeight: 400 }}
          >
            {language === "ru" ? " (развернуть)" : " (expand)"}
          </span>
        </span>
      }
      styles={{ title: { flex: 1, textAlign: 'center' } }}
    >
      {/* Thumbnail + editable tags header, matching the LogbookDropdown
          layout so both overlays feel like siblings. Uses artProp (set
          by the caller from its already-loaded art object) as the
          source of truth — falling back to artEvent.art only when the
          caller didn't pass anything. */}
      {(() => {
        const artForHeader = artProp || artEvent.art;
        if (!artForHeader) return null;
        return (
          <div className="flex justify-center my-2">
            <img
              className="object-cover rounded-lg max-w-[100px]"
              src={artForHeader.thumbnailUrl}
              alt={artForHeader.name || "Art Thumbnail"}
            />
          </div>
        );
      })()}
      {eventType === 'artEvent' && myUser && myUser.myUserInfo?.myUserId === artEvent.event.userID && (
        <div className="flex justify-center mb-2">
          <TagsInput
            key={`overlay-tags-${artEvent.event.id}`}
            language={language}
            editable={true}
            artCategory={(artProp || artEvent.art)?.category}
            initialTags={artEvent.event.eventTags?.map((t) => t.name) || []}
            initialTagObjects={artEvent.event.eventTags || []}
            onTagsChange={(actualTagNames) => {
              axiosInstance
                .post(`/artEvents/tag/${artEvent.event.id}/tag`, { tags: actualTagNames })
                .then((response) => {
                  setArtEvent((prev) => prev ? { ...prev, event: response.data.event } : prev);
                })
                .catch((error) => console.error(error));
            }}
          />
        </div>
      )}
      <MyChatComponent key={artEvent.event.chatId} chatId={artEvent.event.chatId} _userChatInfo={artEvent.chat} language={language} myUserInfo={myUser ? myUser.myUserInfo : null} chatOwnerInfo={{type:eventType, id: artEvent.event.id}} isDropdown={true}/>
    </Drawer>
  );
};

export default ArtEventDropdown;
